@if (showThumbnail) {
  @if (media.length > 0) {
    <div class="relative group p-2">
      <div class="relative images-thread-entity">
        <img
          [src]="displayMedia[0]"
          alt=""
          (error)="onImageLoadError($event)"
          class="size-images object-cover"
        />
        <div
          class="absolute images-tooltip inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          <span
            class="text-white text-center text-sm font-semibold cursor-pointer"
            (click)="open()"
            (keyup)="(null)"
            >View {{ media.length }} image(s)</span
          >
        </div>
      </div>
    </div>
  }
} @else {
  <button
    class="w-[180px] h-[50px]"
    color="primary"
    matButton="filled"
    (click)="open()"
    type="button"
  >
    {{ buttonLabel }}
  </button>
}

<ng-template #galleryActionsTemplate>
  @if (media.length > 0) {
    <div class="flex space-x-2 items-center justify-center">
      <button
        class="material-icons"
        mat-icon-button
        color="primary"
        (click)="prev()"
        [attr.aria-label]="'previous'"
      >
        arrow_back
      </button>
      <span class="flex items-center theme-text-2"
        >{{ currentIndex + 1 }} of {{ media.length }}</span
      >
      <button
        class="material-icons"
        mat-icon-button
        color="primary"
        (click)="next()"
        [attr.aria-label]="'next'"
      >
        arrow_forward
      </button>
    </div>
  }
</ng-template>

<ng-template #dialogGalleryTemplate>
  @if (media.length === 0) {
    <div class="flex justify-center">
      <phoenix-no-data class="mt-20"></phoenix-no-data>
    </div>
  } @else {
    <div class="flex justify-center relative w-full h-[65vh]">
      <img
        class="object-contain"
        [src]="displayMedia[currentIndex]"
        [alt]="media[currentIndex]"
        [attr.aria-label]="'gallery-image'"
        (error)="onImageLoadError($event)"
      />
    </div>
    @if (!disabled) {
      <div class="absolute top-[5px] right-[5px] rounded-[50%]">
        <button
          class="theme-bg-2"
          mat-icon-button
          (click)="removeImage(currentIndex)"
          color="warn"
          matTooltip="Remove image"
          [attr.aria-label]="'remove-image'"
          [disabled]="disabled"
        >
          <mat-icon class="mb-1 text-red-500 material-icons-outlined"
            >delete</mat-icon
          >
        </button>
      </div>
    }
  }
</ng-template>
